import { ButtonHTMLAttributes, forwardRef } from "react";
import {
  getButtonClassName,
  type ButtonSize,
  type ButtonVariant,
} from "@/components/UI/buttonStyles";
import "./Button.css";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = "primary",
      size = "md",
      loading = false,
      disabled,
      className = "",
      children,
      ...rest
    },
    ref,
  ) => {
    const cls = getButtonClassName({ className, size, variant });
    return (
      <button
        ref={ref}
        className={cls}
        disabled={disabled || loading}
        aria-busy={loading || undefined}
        data-loading={loading ? "true" : "false"}
        {...rest}
      >
        {loading ? <span className="btn__spinner" aria-hidden /> : null}
        <span className={loading ? "btn__label btn__label--loading" : "btn__label"}>
          {children}
        </span>
      </button>
    );
  },
);

Button.displayName = "Button";
